import type { TransitionOverride } from '@mantine/core';

export const SELECT_TRANSITION_PROPS: TransitionOverride = {
  transition: 'scale-y',
  duration: 150,
  timingFunction: 'ease-out',
};
